import api from './api';

export const postSystem = (system) => {
  return api.post('/api/v1/battery-energy-storage-systems/simple', system);
};
